<div class="menu-nav" appScrollList [activeIndex]="(activeCategoryIndex$ | async) ?? 0">
  <div class="menu-nav__toggle">
    <button class="menu-nav__button button button--th-second" (click)="onOpenModal()">
      <div class="icon-wrap">
        <i class="icomoon icomoon--menu"></i>
      </div>
    </button>
  </div>

  <div class="menu-nav__inner">
    <div class="menu-nav__scroller">
      <div 
        class="menu-nav__item"
        *ngFor="let item of menuGroups; let i = index"
        [appTooltip]="tooltipMessage"
        [appTooltipDisabled]="!item.isScheduleUnavailable"
      >
        <button
          appScrollButton
          [routerLink]="'/category/' + item.slug"
          [class.is-active]="item.slug === (activeCategorySlug$ | async)"
          class="menu-nav__button button button--th-second"
          type="button"
          (click)="setActiveCategory(item.id, i)"
          [disabled]="item.isScheduleUnavailable"
          [ngClass]="{'is-disable': item.isScheduleUnavailable}"
        >
          <div class="menu-nav__img">
            <picture class="cover-picture" *ngIf="item.buttonImage?.['src']; else itemPlug">
              <source srcset="{{ item.buttonImage['44x44x100.webp'] }}, {{ item.buttonImage['88x88x100.webp'] }} 2x">
              <img src="{{ item.buttonImage['src'] }}" appPictureFallback>
            </picture>
          </div>
          <span class="menu-nav__title">{{ item.name }}</span>
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isShowModal" appModalSwipe
     class="modal l-wrapper"
     [ngClass]="{'modal--mobile _right-direction': breakPoint.isMobile}">
  <div class="modal__overlay" appOverlaySwipe (click)="isShowModal = false"></div>
  <div class="modal__container" appBottomSwipeSheet (swipeAnimationEnd)="onCloseModal()" direction="left">

    <div class="modal__head l-wrapper">
      <div class="modal__title h1" i18n="@@Menu">Menu</div>

      <div class="modal__right">
        <button type="button" class="button_close button_close-round" (click)="onCloseModal()">
          <i class="icomoon icomoon--close"></i>
        </button>
      </div>
    </div>

    <div class="modal__content">
      <div class="modal__body l-wrapper">
        <div class="menu-nav-list">
          <div class="menu-nav-list__item" 
            *ngFor="let item of menuGroups; let i = index"
            [appTooltip]="tooltipMessage"
            [appTooltipDisabled]="!item.isScheduleUnavailable"
          >
            <button
              class="menu-nav-list__button link"
              type="button"
              [routerLink]="'/category/' + item.slug"
              routerLinkActive="is-active"
              (click)="setActiveCategory(item.id, i)"
              [disabled]="item.isScheduleUnavailable"
              [ngClass]="{'is-disable': item.isScheduleUnavailable}"
            >
              <div class="menu-nav-list__img">
                <picture class="cover-picture" *ngIf="item.buttonImage?.['src']; else itemPlug">
                  <source srcset="{{ item.buttonImage['44x44x100.webp'] }}, {{ item.buttonImage['88x88x100.webp'] }} 2x">
                  <img src="{{ item.buttonImage['src'] }}" appPictureFallback>
                </picture>
              </div>
              <span class="menu-nav-list__title h3">
                {{ item.name }}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #itemPlug>
  <i class="icomoon icomoon--dish-placeholder"></i>
</ng-template>
